<template>
    <div v-if="visible" v-click-outside="handleClickOutside"> 
      <v-menu offset-y nudge-left="146" nudge-bottom="6">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" @click.stop="$emit('click')">
            <slot>
              <v-icon size="12" style="padding-bottom: 2px">fa-regular fa-ellipsis</v-icon>
            </slot>
          </div>
        </template>

        <div class="menu-style" :style="{width: width}">
          <div v-for="(option, index) in options" :key="index" @click="handleOptionClick(option)" class="menu-row">
            <hr :class="{'showDivider': option.divider}"/>
            <div class="menu-row-opt">
              <span :style="{fontSize: fontSize}">{{option.label}}</span>
            </div>
          </div>
        </div>
      </v-menu>
    </div>
</template>

<script>
export default {
  name: 'PopUpMenu',
  props: {
    visible: {type: Boolean, default: true},
    options: {type: Array, required: true}, // [{label: 'Renomear', action: () => {}}, divider: false/true]
    width: {type: String, default: '170px'},
    fontSize: {type: String, default: '14px'}
  },

  methods: {
    handleOptionClick (option) {
      option.action()
    },

    handleClickOutside () {
      this.$emit('clickOutside')
    }
  }
}
</script>

<style scoped>
.v-menu__content {
  box-shadow: none;
}

.menu-style {
  display: flex;
  flex-direction: column;
  padding: 10px 12px 10px 12px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid rgba(102, 109, 128, 0.22);
}

.menu-row {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

hr {
  margin: 0px 0px 0px 0px;
  border: none;
  height: 1px;
  background-color: transparent;  
}

hr.showDivider{
  margin: 10px 0px 10px 0px;
  background-color: rgba(102, 109, 128, 0.1);  
}

.menu-style > div:first-of-type hr {
  display: none;
}

.menu-row-opt {
  padding: 6px 12px 6px 12px;
  padding: 6px 12px 6px 12px;
  transition: all 0.3s;
}

.menu-row-opt:hover {
  background-color: aliceblue;
  border-radius: 8px;
  cursor: pointer;
}

span {
  font-family: Inter !important;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}


</style>
